import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const idToken = params.get("id_token");

    if (idToken) {
      localStorage.setItem("firebase_id_token", idToken);
      console.log("User logged in successfully:", idToken);
      navigate("/"); // Redirect to protected page
    } else {
      console.error("Login failed");
      navigate("/social-login"); // Redirect to login page
    }
  }, [navigate]);

  return <h2>Processing login...</h2>;
};

export default AuthCallback;
